export const RatingJobsActionTypes = {
    API_RESPONSE_SUCCESS: '@@rating-jobs/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@rating-jobs/API_RESPONSE_ERROR',
    LAUNCH_RATING_JOB: '@@rating-jobs/LAUNCH_RATING_JOB',
    GET_RATING_JOB_STATUS: '@@rating-jobs/GET_RATING_JOB_STATUS',
    STOP_RATING_JOB: '@@rating-jobs/STOP_RATING_JOB',
    RESTART_RATING_JOB: '@@rating-jobs/RESTART_RATING_JOB',
    GET_ALL_RATING_JOBS: '@@rating-jobs/GET_ALL_RATING_JOBS',
};
